<template>
  <b-modal id="line-details-modal" title="Path Details" @hidden="onCancel" :visible="show" hide-footer>
    <b-form @submit.prevent="onSubmit">
      <b-form-group label="Name:" label-for="name-input">
        <b-form-input
            id="name-input"
            v-model="form.name"
            placeholder="Enter line name"
            required
        ></b-form-input>
      </b-form-group>

      <b-form-group label="Region:" label-for="region-input">
        <b-form-input
            id="region-input"
            v-model="form.region"
            placeholder="Enter region"
        ></b-form-input>
      </b-form-group>

      <b-form-group label="Depth (meters):" label-for="depth-input">
        <b-form-input
            id="depth-input"
            v-model.number="form.depth"
            type="number"
            min="0"
            step="0.1"
            required
        ></b-form-input>
      </b-form-group>

      <b-form-group label="Vessel Length (meters):" label-for="vessel-length-input">
        <b-form-input
            id="vessel-length-input"
            v-model.number="form.vesselLength"
            type="number"
            min="0"
            step="0.1"
        ></b-form-input>
      </b-form-group>

      <b-form-group label="Vessel Breadth (meters):" label-for="vessel-breadth-input">
        <b-form-input
            id="vessel-breadth-input"
            v-model.number="form.vesselBreadth"
            type="number"
            min="0"
            step="0.1"
        ></b-form-input>
      </b-form-group> 

      <b-form-group label="Vessel Height (meters):" label-for="vessel-height-input">
        <b-form-input
            id="vessel-height-input"
            v-model.number="form.vesselHeight"
            type="number"
            min="0"
            step="0.1"
        ></b-form-input>
      </b-form-group> 

       <b-form-group label="Vessel Draught (meters):" label-for="vessel-draught-input">
        <b-form-input
            id="vessel-draught-input"
            v-model.number="form.vesselDraught"
            type="number"
            min="0"
            step="0.1"
        ></b-form-input>
      </b-form-group> 

      <b-form-group label="Vessel Types (comma-separated list):" label-for="vessel-types">
        <b-form-input
            id="vessel-types"
            v-model="form.vesselTypes"
            placeholder="Enter vessel types"
        ></b-form-input>
      </b-form-group>

      <b-form-group label="Status:" label-for="status-select">
        <b-form-select
            id="status-select"
            v-model="form.status"
            :options="statusOptions"
            required
        ></b-form-select>
      </b-form-group>

      <b-form-group label="Type:" label-for="type-select">
        <b-form-select
            id="type-select"
            v-model="form.type"
            :options="typeOptions"
            required
        ></b-form-select>
      </b-form-group>

      <b-form-group label="Source:" label-for="source-select">
        <b-form-select
            id="source-select"
            v-model="form.source"
            :options="sourceOptions"
            required
        ></b-form-select>
      </b-form-group>

      <div class="d-flex justify-content-end mt-3">
        <b-button variant="secondary" class="mr-2" @click="onCancel">{{ $t('editor.cancel') }}</b-button>
        <b-button variant="primary" type="submit">{{ $t('editor.save') }}</b-button>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
export default {
  props: {
    show: Boolean,
    initialValues: {
      type: Object,
      default: () => ({
        name: '',
        region: '',
        depth: 10,
        vesselLength: 0,
        vesselBreadth: 0,
        vesselHeight: 0,
        vesselDraught: 0,
        vesselTypes: '',
        status: 'medium',
        type: 'coastal',
        source: 'map'
      })
    }
  },
  data() {
    return {
      form: { ...this.initialValues },
      statusOptions: [
        { value: 'important', text: 'Important' },
        { value: 'medium', text: 'Medium' },
        { value: 'unimportant', text: 'Unimportant' }
      ],
      typeOptions: [
        { value: 'approach', text: 'Approach' },
        { value: 'coastal', text: 'Coastal' },
        { value: 'marine', text: 'Marine' },
        { value: 'ocean', text: 'Ocean' },
        { value: 'river', text: 'River' },
        { value: 'channel', text: 'Channel' },
        { value: 'gateway', text: 'Gateway' }
      ],
      sourceOptions: [
        { value: 'map', text: 'Map' },
        { value: 'expert', text: 'Expert' }
      ]
    };
  },
  watch: {
    initialValues: {
      handler(newVal) {
        this.form = { ...newVal };
      },
      deep: true
    }
  },
  methods: {
    onSubmit() {
      this.$emit('submit', { ...this.form });
    },
    onCancel() {
      this.$emit('cancel');
    }
  }
}
</script>